/**
 * @author gyb(mocheer)
 * @since 2016.11.4
 * 
 * @see https://github.com/htoooth/Leaflet.ChineseTmsProviders
 * @see https://github.com/mylen/leaflet.TileLayer.WMTS
 * @see https://github.com/ywqyunshan/LeafletGIS/blob/fe6f2a323f0903f29c1a6db7fef76b2c29909dc9/js/page_mapload_customcrs.js
 * @see https://github.com/za59418/TestLeaflet/blob/a6c15d34766130440eea6599be7aa610b23987d1/projects/LeafletClient/lib/leaflet/CRS2379.js
 */
import TencentMap from './provider/TencentMap';
import DMap from './provider/DMap';
// import BaiduMap from './provider/BaiduMap';
//
let { assign: $assign } = T;
let { TileLayer, CRS } = L;
/**
 * 地图瓦片图层服务
 */
export default class Provider extends L.LayerGroup {
  crs = CRS.EPSG3857;
  name;
  zoom;
  /**
   * 
   */
  addTo(map) {
    this.updateCRS(this.crs, map);
    return super.addTo(map);
  }
  /**
   * 更新crs
   */
  updateCRS(crs, map) {
    if (!crs) return;
    if (typeof crs === 'string') {
      crs = CRS[crs];
    }
    map = this.map = map || this._map || this.map;
    //
    if (map) {
      let { options } = map;
      let center = map.getCenter();
      let { zoom } = this;
      zoom = zoom || map._zoom;
      // 如果上一个坐标系是4326,图层清除之后,层级会发生变化
      if (options.crs == CRS.EPSG4326) {
        T.defer(() => {
          map.setZoom(zoom); //重新设置层级
        })
      }
      // 如果坐标系不一样
      if (options.crs !== crs) {
        zoom += (crs === CRS.EPSG4326) ? -1 : 1;//待修改 zoomOffset
        options.crs = crs;
        map.setView(center, zoom); // 改变crs会改变中心点
        map._resetView(center, zoom, true); // 重新绘制图层
      }
      // 
    }
    this.crs = crs;
  }
  /**
   * 
   * @param options 
   * 1、string privder              GaodeMap.Normal
   * 2、{options,url}               {url,options:{zoomOffset,minZoom}}
   * 3、object {crs,name,provider}  {crs:'EPSG3857',provider:{}}
   * 4、array []
   */
  addLayers(options) {
    let groups;
    if (T.isArray(options)) {
      groups = options.map(item => this.create(item));
    } else {
      if (typeof options === 'string' || !options.provider) {
        this.name = options;
        groups = [this.create(options)]
      } else {//  {crs:'EPSG3857',provider:{}}
        options.crs && this.updateCRS(options.crs);
        this.name = options.name;
        return this.addLayers(options.provider || options);
      }
    }
    let layers = L.layerGroup(groups);
    this.addLayer(layers);
    //
    return layers;
  }
  /**
   * 
   * @param options 
   */
  updateLayers(options) {
    // 当 crs == CRS.EPSG4326 时 清除图层后获取到zoom为之前图层的最大层级
    this.zoom = this._map._zoom; // || 0;
    //
    return this.clearLayers().addLayers(options);
  }
  /**
   * 
   * @param options 
   * { name: 'DMap', options: { url: 'http://192.168.118.226:50024/WebApi/api/v1/map/tile/local?id={id}&name=wz' } }
   */
  create(options) {
    let url;
    let name;
    if (typeof options === 'object') {
      name = options.name;
      url = options.url;
      options = options.options;
    } else {
      name = options;
      options = null;
    }

    let Layer = TileLayer;
    if (name) {
      let basemap = Provider.basemap[this.crs.code];
      // if (this.crs === CRS.Baidu09) {
      //   Layer = BaiduMap;
      // }
      if (!basemap) {
        console.warn('不存在图包:' + name);
        return;
      }
      let parts = name.split('.');
      let providerName = parts[0];
      let src = basemap[providerName];
      switch (providerName) {
        case 'TencentMap':
          Layer = TencentMap;
          break;
        case 'DMap':
          Layer = DMap;
          break;
      }

      if (src) {
        let { options: op } = src;
        let variantName = parts[1];
        // 变化v -> variants
        if (variantName) {
          let variant = src.v[variantName];
          let vo;
          if (typeof variant === 'string') {
            vo = { v: variant };
          } else {
            url = url || variant.url;
            vo = variant.options;
          }
          op = $assign({}, op, vo)
        }
        url = url || src.url;
        options = $assign({}, op, options)
      }
    }

    return new Layer(url, options);
  }
  /**
   * 基础地图
   */
  static basemap = {
    'EPSG:3857': {
      /**
       * 谷歌地图
       */
      GoogleMap: { //http://www.google.cn/maps/vt?lyrs={v}@{s}&gl=cn&x={x}&y={y}&z={z}
        url: 'http://mt{s}.google.cn/vt/lyrs={v}&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}',
        options: {
          subdomains: '0123'
        },
        v: {
          Normal: 'm',     //全地图
          Satellite: 's',  //卫星图
          Terrain: 't',    //地形图
          Terrain_R: 'p',  //地形图+
          Skeleton_D: 'r', //黑色轮廓图dark
          Skeleton_H: 'h', //高亮轮廓图light
          Hybrid: 'y'      //混合卫星图/影像图?
        }
      },
      /**
       * 百度地图
       */
      BaiduMap: {
        url: "http://online{s}.map.bdimg.com/tile/?qt=tile&x={x}&y={y}&z={z}&styles={v}&v=020",
        options: {
          minZoom: 3,
          maxZoom: 19,
          subdomains: '0123456789',
          tms: true
        },
        v: {
          Normal: 'pl',
          A: 'sl',
          Satellite: { url: 'http://shangetu{s}.map.bdimg.com/it/u=x={x};y={y};z={z};v=009;type=sate&fm=46' },
        }
      },
      /**
       * 全国天地图 
       */
      Tianditu: {
        url: 'http://t{s}.tianditu.com/DataServer?T={v}&x={x}&y={y}&l={z}',
        // url = 'http://t{s}.tianditu.com/cva_c/wmts/{z}/{y}/{x}' 错误的服务地址？
        // url = 'http://t{s}.tianditu.cn/vec_c/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=c&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&FORMAT=tiles',//4326
        options: {
          subdomains: '01234567',
        },
        v: {
          Normal: 'vec_w',        //矢量地图
          Normal_A: 'cva_w',      //矢量-标注图
          Terrain: 'ter_w',       //地形图
          Terrain_A: 'cta_w',     //地形-标注图
          Satellite: 'img_w',     //卫星影像图
          Satellite_A: 'cia_w',   //卫星-标注图
        }
      },
      /**
       * 高德地图
       */
      GaodeMap: {
        url: 'http://web{v}0{s}.is.autonavi.com/appmaptile?style={style}&x={x}&y={y}&z={z}',
        options: {
          minZoom: 3,
          subdomains: '1234',
          attribution: '&copy; <a>GaoDeMap</a>'
        },
        v: {
          Normal: {     // 交通图
            url: 'http://webrd0{s}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
          },
          Satellite: {  // 卫星图
            options: { v: 'st', style: 6 }
          },
          Satellite_A: { // 卫星-标注图
            options: { v: 'st', style: 8 }
          }
        }
      },
      /**
       * 腾讯地图
       */
      TencentMap: {
        url: 'http://rt{s}.map.gtimg.com/realtimerender?z={z}&x={x}&y={y}&type=vector&style={v}',
        options: {
          subdomains: '012'
        },
        v: {
          Normal: '0',
          Normal_R: '1',
          Terrain: 'demTiles',//地形图
          Satellite: 'sateTiles'//卫星图
        }
      }
    },
    'EPSG:4326': {
      /**
       * 全国天地图 4490
       */
      Tianditu: {
        url: 'http://t{s}.tianditu.com/DataServer?T={v}&x={x}&y={y}&l={z}',
        options: {
          zoomOffset: 1,
          subdomains: '01234567'
        },
        v: {
          Normal: 'vec_c',     //矢量地图
          Normal_A: 'cva_c',   //矢量-标注图
          Terrain: 'ter_c',    //地形图
          Terrain_A: 'cta_c',  //地形-标注图
          Satellite: 'img_c',  //卫星影像图
          Satellite_A: 'cia_c',//卫星-标注图
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/Provider.js